import styles from './M_CapsuleCard.module.css';
import W_CapsuleCreators from '@/components/W_Wrappers/W_CapsuleCreators/W_CapsuleCreators';
import { Link } from 'react-router-dom';
import cn from 'classnames';
import { Q_Icon } from '@/components/Q_Quarks/Q_Icon/Q_Icon';
import { getMediaUrl } from '@/utils/mediaUrl';

interface M_CapsuleCardProps {
  image?: string;
  title: string;
  avatars: string[];
  coauthors: number;
  commentsCount?: number;
  isMyCapsule: boolean;
  ownerName: string;
  ownerId?: string;
  id: string;
  isAdminCapsule?: boolean;
}

export default function M_CapsuleCard({
  image,
  title,
  avatars,
  coauthors,
  commentsCount = 0,
  isMyCapsule,
  ownerName,
  ownerId,
  id,
  isAdminCapsule = false,
}: M_CapsuleCardProps) {
  const contentClassName = cn(styles.content_wrapper, {
    [styles.content_wrapper_admin]: isAdminCapsule,
  });
  const titleClassName = cn(styles.title, {
    [styles.title_admin]: isAdminCapsule,
  });

  return (
    <Link
      to={`/capsule/${id}`}
      className={cn(styles.wrapper, { [styles.wrapper_no_preview]: !image })}
    >
      <div className={styles.image_wrapper}>
        {image ? <img src={getMediaUrl(image)} alt='Capsule' /> : null}
      </div>
      <div className={contentClassName}>
        <h4 className={titleClassName}>{title}</h4>
        <div className={styles.meta_row}>
          {isAdminCapsule ? (
            <div className={styles.admin_brand}>
              <div className={styles.admin_logo}>
                <Q_Icon.LogoIcon width={24} height={24} />
              </div>
              <span className={cn(styles.admin_name, 'text-p-7')}>
                TimeCaps
              </span>
            </div>
          ) : (
            <W_CapsuleCreators
              avatars={avatars}
              coauthors={coauthors}
              isMyCapsule={isMyCapsule}
              ownerName={ownerName}
              ownerId={ownerId}
            />
          )}
          <div className={styles.comments_count}>
            <Q_Icon.CommentIndicatorIcon width={24} height={24} fill='none' />
            <span className='text-p-6'>{commentsCount}</span>
          </div>
        </div>
      </div>
    </Link>
  );
}
